var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#38BDF8",
    d: "M24 9c-6 0-9.5 3-10.5 9 2-3 4.5-4 7.5-3 1.6.5 2.7 1.8 3.9 3.2 2 2.4 4.3 5 9.1 5 6 0 9.5-3 10.5-9-2 3-4.5 4-7.5 3-1.6-.5-2.7-1.8-3.9-3.2C31.6 11.6 29.3 9 24 9zm-10 14c-6 0-9.5 3-10.5 9 2-3 4.5-4 7.5-3 1.6.5 2.7 1.8 3.9 3.2 2 2.4 4.3 5 9.1 5 6 0 9.5-3 10.5-9-2 3-4.5 4-7.5 3-1.6-.5-2.7-1.8-3.9-3.2C21.6 26.6 19.3 23 14 23z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a5b92e1d578cc438a856c13b1f494c4c.svg";
export { ForwardRef as ReactComponent };